import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import adminService from '../../services/adminService';

const initialState = {
  users: [],
  auditLogs: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
  userPagination: { page: 1, totalPages: 1, total: 0 },
  auditPagination: { page: 1, totalPages: 1, total: 0 },
  metrics: null,
  recentUsers: [],
  recentAudit: [],
};

// Thunks
export const adminFetchUsers = createAsyncThunk('admin/fetchUsers', async (params, thunkAPI) => {
  try { return await adminService.fetchAdminUsers(params); } catch (e) { return thunkAPI.rejectWithValue(e.response?.data?.message || e.message); }
});
export const adminToggleUserActivation = createAsyncThunk('admin/toggleUserActivation', async ({ id, isActive }, thunkAPI) => {
  try { return await adminService.toggleUserActivation(id, isActive); } catch (e) { return thunkAPI.rejectWithValue(e.response?.data?.message || e.message); }
});
export const adminVerifyUser = createAsyncThunk('admin/verifyUser', async ({ id, status, notes }, thunkAPI) => {
  try { return await adminService.verifyUser(id, status, notes); } catch (e) { return thunkAPI.rejectWithValue(e.response?.data?.message || e.message); }
});
export const adminFetchAuditLogs = createAsyncThunk('admin/fetchAuditLogs', async (params, thunkAPI) => {
  try { return await adminService.fetchAuditLogs(params); } catch (e) { return thunkAPI.rejectWithValue(e.response?.data?.message || e.message); }
});
export const adminFetchStats = createAsyncThunk('admin/fetchStats', async (_, thunkAPI) => {
  try { return await adminService.fetchStats(); } catch (e) { return thunkAPI.rejectWithValue(e.response?.data?.message || e.message); }
});

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false; state.isError = false; state.isSuccess = false; state.message='';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminFetchUsers.pending, (state) => { state.isLoading = true; })
      .addCase(adminFetchUsers.fulfilled, (state, action) => {
        state.isLoading = false; state.isSuccess = true; state.users = action.payload.users; state.userPagination = { page: action.payload.page, totalPages: action.payload.totalPages, total: action.payload.total };
      })
      .addCase(adminFetchUsers.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; })
      .addCase(adminToggleUserActivation.fulfilled, (state, action) => {
        state.users = state.users.map(u => u._id === action.payload.id ? { ...u, isActive: action.payload.isActive } : u);
      })
      .addCase(adminVerifyUser.fulfilled, (state, action) => {
        state.users = state.users.map(u => u._id === action.payload.id ? { ...u, verification: action.payload.verification } : u);
      })
      .addCase(adminFetchAuditLogs.pending, (state) => { state.isLoading = true; })
      .addCase(adminFetchAuditLogs.fulfilled, (state, action) => {
        state.isLoading = false; state.isSuccess = true; state.auditLogs = action.payload.logs; state.auditPagination = { page: action.payload.page, totalPages: action.payload.totalPages, total: action.payload.total };
      })
      .addCase(adminFetchAuditLogs.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; });
    builder
      .addCase(adminFetchStats.pending, (state) => { state.isLoading = true; })
      .addCase(adminFetchStats.fulfilled, (state, action) => {
        state.isLoading = false; state.isSuccess = true; state.metrics = action.payload.metrics; state.recentUsers = action.payload.recentUsers; state.recentAudit = action.payload.recentAudit;
      })
      .addCase(adminFetchStats.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; });
  }
});

export const { reset } = adminSlice.actions;
export default adminSlice.reducer;